"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tablePanelStyle = void 0;
const react_1 = require("@emotion/react");
exports.tablePanelStyle = (0, react_1.css) `
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .inner-container {
    height: 100%;
    overflow: hidden;
    isolation: isolate;
  }

  .table-container {
    overflow: auto;
    height: 100%;
    display: block;
    background-color: white;
  }
`;
